import {GetSimilarPropertiesResponseModel, SearchPropertyModel} from '../../../shared/models/properties/properties.models';
import {createReducer, on} from '@ngrx/store';
import {DefaultStoreState} from '../../models/app-state.model';
import { SimilarPropertiesActions } from '../../actions/property/similar-properties.actions';

export const similarPropertiesKey = 'similarProperties';

export interface State extends DefaultStoreState {
  details: SearchPropertyModel[];
}

const initialState: State = {
  details: null,
  isLoading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(
    SimilarPropertiesActions.loadSimilarProperties,
    (state: State) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    SimilarPropertiesActions.loadSimilarPropertiesSuccess,
    (state: State, res: GetSimilarPropertiesResponseModel) => ({
      ...state,
      details: res.data,
      isLoading: false
    })
  ),
  on(
    SimilarPropertiesActions.loadSimilarPropertiesFailure,
    (state: State, error) => ({
      ...state,
      error
    })
  ),
);
